import { useState } from 'react';
import { Link } from 'react-router-dom';
import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import i18n from '../common/i18n';
import '../../assests/css/headerStyle.css';
import {
  AUTOGESTION, COMMERCE, PERSONAL_ADWORDS_LOAN_URL,
} from '../../api/env';
import safeGetEnv from '../../prerender';

const ORIGINACION_WT_LINK = safeGetEnv(PERSONAL_ADWORDS_LOAN_URL);

const SideBarMenu = () => {
  // "Dónde comprar" queda fuera del menú: apuntaba a comercios físicos, dado de baja.
  const navItems = [
    i18n.headerMenuHome,
    i18n.headerMenuBlog,
    i18n.headerMenuHelp,
  ];
  const [mobileOpen, setMobileOpen] = useState(false);
  const COMMERCE_LINK = safeGetEnv(COMMERCE);
  const CLIENT_LINK = safeGetEnv(AUTOGESTION);

  const accessItems = [
    {
      title: i18n.headerClient,
      link: CLIENT_LINK,
      icon: <PersonOutlineOutlinedIcon />,
    },
    {
      title: i18n.headerCommerce,
      link: COMMERCE_LINK,
      icon: <StorefrontOutlinedIcon />,
    },
  ];

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const pushEvent = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'select_item',
      ecommerce: {
        items: [{
          item_name: 'Tradicional Web',
        }],
      },
    });
  };

  return (
    <>
      <Drawer
        variant="temporary"
        open={mobileOpen}
        anchor="right"
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        PaperProps={{ className: 'sideBarDrawer' }}
      >
        <Box onClick={handleDrawerToggle}>
          <List className="menuHamburguesa sideBarList">
            {navItems.map((item) => (item
                  && (
                    <ListItem key={item?.title} disablePadding>
                      <ListItemButton
                        className="sideBarItemButton"
                        component={Link}
                        to={item?.route}
                      >
                        <ListItemText primary={item?.title} className="sideBarItemText" />
                      </ListItemButton>
                    </ListItem>
                  )
            ))}

            <Divider className="sideBarDivider" />

            {accessItems.map((item) => (
              <ListItem key={item.title} disablePadding>
                <ListItemButton
                  className="sideBarItemButton"
                  component="a"
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                >
                  <ListItemIcon className="sideBarItemIcon">
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText primary={item.title} className="sideBarItemText" />
                  <ChevronRightIcon className="sideBarArrow" />
                </ListItemButton>
              </ListItem>
            ))}

            <ListItem key={i18n.headerMenuWt.title} disablePadding>
              <ListItemButton
                className="sideBarItemButton sideBarItemHighlight"
                onClick={pushEvent}
                component="a"
                href={ORIGINACION_WT_LINK}
                target="_blank"
                rel="noopener noreferrer"
              >
                <ListItemIcon className="sideBarItemIcon">
                  <StarBorderOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary={i18n.headerMenuWt.title} className="sideBarItemText" />
                <ChevronRightIcon className="sideBarArrow" />
              </ListItemButton>
            </ListItem>
          </List>
        </Box>
      </Drawer>
      <IconButton
        onClick={handleDrawerToggle}
        className="iconButton"
      >
        <MenuIcon />
      </IconButton>
    </>
  );
};

export default SideBarMenu;
